module.exports = __webpack_public_path__ + "static/koperasi-indonesia-899acab40ec12c4360fca51bbd818e2d.png";